// extracted by mini-css-extract-plugin
export default {"Break":"Break_Break__3glwy"};